import React from 'react';

import FeedCard from '../../components/feed-card';
import { IFeedCardContainer } from '../../models/moments-report/feed-card';

const FeedCardContainer = ({ details, name }: IFeedCardContainer) => {
    return (
        <>
            <h6 className="hdr-lg-02">{name}</h6>
            <div className="card-group-01">
                {details?.map((item, index) => (
                    <FeedCard key={'feed-card-' + index} name={item?.name} count={item?.count} icon={item?.icon} />
                ))}
            </div>
        </>
    );
};

export default FeedCardContainer;
